<template>
  <button
    :class="clsx('ui-button', {
      'ui-button--loading': isLoading,
      'ui-button--disabled': isDisabled || isLoading,
      [`ui-button--size-${size}`]: true
    })"
    :disabled="isDisabled || isLoading"
    v-on="$listeners"
  >
    <span class="ui-button__content" v-if="!isLoading">
      <slot />
    </span>
    <span class="ui-button__loader" v-if="isLoading">
      <SpinnerLoader />
    </span>
  </button>
</template>

<script>
import { clsx } from 'clsx';
import { SpinnerLoader } from '@/shared/ui/loader';

export default {
  components: { SpinnerLoader },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'small', 'large'].includes(value),
    },
  },
  methods: { clsx },
};
</script>

<style lang="scss" scoped>
.ui-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: inherit;
  font-weight: 500;
  border: 1px solid #0A77FF;
  border-radius: 8px;
  background-color: #FFFFFF;
  color: #0A77FF;
  padding: 8px 12px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
  white-space: nowrap;

  &__content {
    display: inline-flex;
    align-items: center;
  }
}

.ui-button:hover:not(:disabled) {
  background-color: #E8F1FF;
  border-color: #0968E0;
}

.ui-button:active:not(:disabled) {
  opacity: 0.8;
}

.ui-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(10, 119, 255, 0.3);
}

.ui-button--size-default {
  padding: 8px 12px;
  font-size: 14px;
}

.ui-button--size-small {
  padding: 6px 10px;
  font-size: 12px;
}

.ui-button--size-large {
  padding: 12px 18px;
  font-size: 16px;
}

.ui-button:disabled,
.ui-button--disabled {
  cursor: not-allowed;
  pointer-events: none;
  background-color: #F5F5F5;
  color: #949494;
  border-color: #E2E8F0;
}

.ui-button--loading {
  .ui-button__content {
    visibility: hidden;
  }
  .ui-button__loader {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.ui-button__loader {
  display: flex;
  align-items: center;
  margin-left: 8px;
}
</style>
